<template>
    <div class="card mb-3">
        <div class="card-header dropdown">
            <span class="d-inline-block mr-3">
                {{ this.name }}
            </span>
            <span @click="moveUpBlock" class="sort-blocks d-inline-block cursor-pointer text-muted text-sm tracking-wide font-weight-normal" :title="'Order ascending ' + name" :aria-label="'Order ascending ' + name">
                <i aria-hidden="true" class="fa fa-arrow-up"></i>
            </span>
             <span @click="moveDownBlock" class="sort-blocks d-inline-block cursor-pointer text-muted text-sm tracking-wide font-weight-normal" :title="'Order descending ' + name" :aria-label="'Order descending ' + name">
                <i aria-hidden="true" class="fa fa-arrow-down"></i>
            </span>
            <span @click="deleteBlock" class="float-right cursor-pointer" :title="'Delete ' + name" :aria-label="'Delete ' + name">
                <i aria-hidden="true" class="fa fa-trash"></i>
            </span>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index:Number,
        name:String
    },
    methods: {
        deleteBlock(){
            if(confirm("Are you sure you want to delete " + this.name + "?")){
                     this.$store.dispatch('deleteBlock', { 'index' : this.index })
            }
        },
        moveUpBlock() {
            this.$store.dispatch('moveUpBlock', { 'index' : this.index })
        },
        moveDownBlock() {
            this.$store.dispatch('moveDownBlock', { 'index' : this.index })
        }
    }
}
</script>

<style lang="scss">
span.sort-blocks:hover {
    color: #6cb2eb !important;
}
</style>